import { ReactElement } from 'react';
import { Center, Text, VStack } from '@chakra-ui/react';
import { CheckMarkIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';

export const FeedbackSuccessMessage = (): ReactElement => (
  <VStack align="center" gap="3xs" bg="background.canvas" py="s" px="s">
    <Center bg="green.500" borderRadius="100%" p="2xs">
      <NovaIcon icon={CheckMarkIcon} size="s" color="grey.white" aria-hidden />
    </Center>
    <Text textStyle="h6.medium" textAlign="center">
      Vielen Dank für dein Feedback!
    </Text>
  </VStack>
);
